export default __webpack_public_path__ + "static/media/intro.b2976dd0.jpg";